import { render } from "./AcceptedGSCView.vue?vue&type=template&id=d548f7e4&scoped=true"
const script = {}

import "./AcceptedGSCView.vue?vue&type=style&index=0&id=d548f7e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d548f7e4"]])

export default __exports__